import React from 'react';
import { render } from 'react-dom';
import { makeData, Logo, Tips } from '../Utility/utility.js';
import matchSorter from 'match-sorter';
import Slider from 'rc-slider';
import Tooltip from 'rc-tooltip';
import 'rc-slider/assets/index.css';
import { AppContext } from '../Pages/App';
import { FadeLoader } from 'react-spinners';

// Import React Table
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import './ContractTable.css';
import latinize from 'latinize';

const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Range = createSliderWithTooltip(Slider.Range);
const Handle = Slider.Handle;

export class ContractTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      prospects: this.props.prospects,
      data: this.props.data
    };
  }
  columns = [
    {
      Header: 'Player',
      id: 'player',
      accessor: d => d.player_name,
      defaultSortDesc: false,
      filterMethod: (filter, row) => {
        return row[filter.id]
          ? latinize(row[filter.id])
              .toLowerCase()
              .includes(filter.value)
          : null;
      }
    },
    {
      Header: 'Age',
      id: 'age',
      accessor: d => d.age,
      width: 50,
      filterMethod: (filter, row) => {
        return (
          row[filter.id] >= filter.value[0] && row[filter.id] <= filter.value[1]
        );
      }
    },
    {
      Header: 'Team',
      id: 'team',
      accessor: d => d.team,
      defaultSortDesc: false,
      SortMethod: (a, b, desc) => {
        a = a === null || a === undefined ? -Infinity : a;
        b = b === null || b === undefined ? -Infinity : b;
        if (a > b) {
          return 1;
        }
        if (a < b) {
          return -1;
        }
      },
      width: 50
    },
    {
      Header: 'POS',
      id: 'position',
      accessor: d => d.position,
      width: 50
    },
    {
      Header: 'Handed',
      id: 'handed',
      accessor: d => d.handedness,
      width: 60
    },
    {
      Header: 'Points',
      id: 'points',
      accessor: d => d.points,
      width: 60,
      filterMethod: (filter, row) => {
        return (
          row[filter.id] >= filter.value[0] && row[filter.id] <= filter.value[1]
        );
      }
    },
    {
      Header: '19-20 Cap HIT',
      id: 'capHit',
      accessor: d =>
        d.contracts
          ? d.contracts.find(x => x.season == '20192020')
            ? d.contracts.find(x => x.season == '20192020').cap_hit
              ? '$' +
                d.contracts
                  .find(x => x.season == '20192020')
                  .cap_hit.toLocaleString()
              : null
            : null
          : null,
      sortMethod: (a, b, desc) => {
        a =
          a === null
            ? desc
              ? -Infinity
              : Infinity
            : Number(
                a
                  .split('$')[1]
                  .split(',')
                  .join('')
              );
        b =
          b === null
            ? desc
              ? -Infinity
              : Infinity
            : Number(
                b
                  .split('$')[1]
                  .split(',')
                  .join('')
              );
        if (a > b) {
          return 1;
        }
        if (a < b) {
          return -1;
        }
        return 0;
      },
      filterMethod: (filter, row) => {
        if (row[filter.id]) {
          return (
            Number(
              row[filter.id]
                .split('$')[1]
                .split(',')
                .join('')
            ) >= filter.value[0] &&
            Number(
              row[filter.id]
                .split('$')[1]
                .split(',')
                .join('')
            ) <= filter.value[1]
          );
        }
      }
    },
    {
      Header: 'Expiration',
      id: 'expiratiion',
      accessor: d =>
        d.contracts.find(x => x.cap_hit === null)
          ? d.contracts
              .find(x => x.cap_hit === null)
              .season.toString()
              .substring(0, 4)
          : d.contracts[d.contracts.length - 1].season.toString().substring(4),
      width: 80,
      filterMethod: (filter, row) => {
        return (
          row[filter.id] >= filter.value[0] && row[filter.id] <= filter.value[1]
        );
      }
    },
    {
      Header: 'Status',
      id: 'status',
      accessor: d => d.expiry_status,
      width: 60
    },
    {
      Header: '19-20 HENRI',
      id: 'henri1920',

      sortMethod: (a, b, desc) => {
        a =
          a === null
            ? desc
              ? -Infinity
              : Infinity
            : Number(
                a
                  .split('$')[1]
                  .split(',')
                  .join('')
              );
        b =
          b === null
            ? desc
              ? -Infinity
              : Infinity
            : Number(
                b
                  .split('$')[1]
                  .split(',')
                  .join('')
              );
        if (a > b) {
          return 1;
        }
        if (a < b) {
          return -1;
        }
        return 0;
      },
      accessor: d =>
        d.contracts
          ? d.contracts.find(x => x.season == '20192020')
            ? d.contracts.find(x => x.season == '20192020').henri
              ? '$' +
                d.contracts
                  .find(x => x.season == '20192020')
                  .henri.toLocaleString()
              : null
            : null
          : null,
      filterMethod: (filter, row) => {
        if (row[filter.id]) {
          return (
            Number(
              row[filter.id]
                .split('$')[1]
                .split(',')
                .join('')
            ) >= filter.value[0] &&
            Number(
              row[filter.id]
                .split('$')[1]
                .split(',')
                .join('')
            ) <= filter.value[1]
          );
        }
      }
    },
    {
      Header: '20-21 HENRI',
      id: 'henri2021',
      sortMethod: (a, b, desc) => {
        a =
          a === null
            ? desc
              ? -Infinity
              : Infinity
            : Number(
                a
                  .split('$')[1]
                  .split(',')
                  .join('')
              );
        b =
          b === null
            ? desc
              ? -Infinity
              : Infinity
            : Number(
                b
                  .split('$')[1]
                  .split(',')
                  .join('')
              );
        if (a > b) {
          return 1;
        }
        if (a < b) {
          return -1;
        }
        return 0;
      },
      accessor: d =>
        d.contracts
          ? d.contracts.find(x => x.season == '20202021')
            ? d.contracts.find(x => x.season == '20202021').henri
              ? '$' +
                d.contracts
                  .find(x => x.season == '20202021')
                  .henri.toLocaleString()
              : null
            : null
          : null,
      filterMethod: (filter, row) => {
        if (row[filter.id]) {
          return (
            Number(
              row[filter.id]
                .split('$')[1]
                .split(',')
                .join('')
            ) >= filter.value[0] &&
            Number(
              row[filter.id]
                .split('$')[1]
                .split(',')
                .join('')
            ) <= filter.value[1]
          );
        }
      }
    },
    {
      Header: '21-22 HENRI',
      id: 'henri2122',
      sortMethod: (a, b, desc) => {
        a =
          a === null
            ? desc
              ? -Infinity
              : Infinity
            : Number(
                a
                  .split('$')[1]
                  .split(',')
                  .join('')
              );
        b =
          b === null
            ? desc
              ? -Infinity
              : Infinity
            : Number(
                b
                  .split('$')[1]
                  .split(',')
                  .join('')
              );
        if (a > b) {
          return 1;
        }
        if (a < b) {
          return -1;
        }
        return 0;
      },
      accessor: d =>
        d.contracts
          ? d.contracts.find(x => x.season == '20212022')
            ? d.contracts.find(x => x.season == '20212022').henri
              ? '$' +
                d.contracts
                  .find(x => x.season == '20212022')
                  .henri.toLocaleString()
              : null
            : null
          : null,
      filterMethod: (filter, row) => {
        if (row[filter.id]) {
          return (
            Number(
              row[filter.id]
                .split('$')[1]
                .split(',')
                .join('')
            ) >= filter.value[0] &&
            Number(
              row[filter.id]
                .split('$')[1]
                .split(',')
                .join('')
            ) <= filter.value[1]
          );
        }
      }
    },
    {
      Header: '19-20 Surplus',
      id: 'surplus',
      sortMethod: (a, b, desc) => {
        a =
          a === null
            ? desc
              ? -Infinity
              : Infinity
            : Number(
                a
                  .split('$')[1]
                  .split(',')
                  .join('')
              );
        b =
          b === null
            ? desc
              ? -Infinity
              : Infinity
            : Number(
                b
                  .split('$')[1]
                  .split(',')
                  .join('')
              );
        if (a > b) {
          return 1;
        }
        if (a < b) {
          return -1;
        }
        return 0;
      },
      accessor: d =>
        d.contracts
          ? d.contracts.find(x => x.season == '20192020')
            ? d.contracts.find(x => x.season == '20192020').surplus
              ? '$' +
                d.contracts
                  .find(x => x.season == '20192020')
                  .surplus.toLocaleString()
              : null
            : null
          : null,
      filterMethod: (filter, row) => {
        if (row[filter.id]) {
          return (
            Number(
              row[filter.id]
                .split('$')[1]
                .split(',')
                .join('')
            ) >= filter.value[0] &&
            Number(
              row[filter.id]
                .split('$')[1]
                .split(',')
                .join('')
            ) <= filter.value[1]
          );
        }
      }
    }
  ];

  handleChange(e, id) {
    this.refs.contractTable.filterColumn(this.columns[id], e.target.value);
  }
  handleRangeChange(e, id) {
    this.refs.contractTable.filterColumn(this.columns[id], e);
  }
  handleHenriChange(e, id) {
    let range = [e[0].toLocaleString(), e[1].toLocaleString()];
    this.refs.contractTable.filterColumn(this.columns[id], range);
  }

  render() {
    const { data } = this.state;
    const handle = props => {
      const { value, dragging, index, ...restProps } = props;
      return (
        <Tooltip
          prefixCls="rc-slider-tooltip"
          overlay={value}
          visible={dragging}
          placement="bottom"
          key={index}
        >
          <Handle value={value} {...restProps} />
        </Tooltip>
      );
    };
    return (
      <div className="contract-table-body">
        <div
          style={{
            display: 'flex',
            color: '#4f738e',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '1em',
            flex: '1'
          }}
        >
          <div style={{ width: '15%' }}>
            <strong>Age:</strong>
            <Range
              defaultValue={[18, 50]}
              min={0}
              max={50}
              allowCross={false}
              tipFormatter={value => `${value}`}
              railStyle={{ background: '#133B57' }}
              onChange={e => this.handleRangeChange(e, 1)}
            />
          </div>
          <div>
            <strong>Team:</strong>
            <select onChange={e => this.handleChange(e, 2)} class="filter">
              <option value="">All</option>
              <AppContext.Consumer>
                {context =>
                  context.number.map(item => (
                    <option value={item.tricode}>{item.full_team_name}</option>
                  ))
                }
              </AppContext.Consumer>
            </select>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <strong>Handed:</strong>
            <div
              onChange={e => this.handleChange(e, 4)}
              style={{ display: 'flex', paddingLeft: '1em' }}
            >
              <div class="radioButton">
                <label>ALL</label>
                <input type="radio" name="handed" value="" />
              </div>
              <div class="radioButton">
                <label>LH</label>
                <input type="radio" name="handed" value="L" />
              </div>
              <div class="radioButton">
                <label>RH</label>
                <input type="radio" name="handed" value="R" />
              </div>
            </div>
          </div>
          <div>
            <strong>Position:</strong>
            <select onChange={e => this.handleChange(e, 3)} class="filter">
              <option value="">All</option>
              <option value="C">C</option>
              <option value="LW">LW</option>
              <option value="RW">RW</option>
              <option value="LD">LD</option>
              <option value="RD">RD</option>
              <option value="G">G</option>
            </select>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <strong>Status:</strong>
            <div
              onChange={e => this.handleChange(e, 8)}
              style={{ display: 'flex', paddingLeft: '1em' }}
            >
              <div class="radioButton">
                <label>ALL</label>
                <input type="radio" name="status" value="" />
              </div>
              <div class="radioButton">
                <label>UFA</label>
                <input type="radio" name="status" value="UFA" />
              </div>
              <div class="radioButton">
                <label>RFA</label>
                <input type="radio" name="status" value="RFA" />
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            color: '#4f738e',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '1em',
            flex: '1'
          }}
        >
          <div>
            <input
              onChange={e => this.handleChange(e, 0)}
              placeholder={'Search Players'}
            />
          </div>
          <div style={{ width: '10%' }}>
            <strong>Points:</strong>
            <Range
              defaultValue={[0, 120]}
              min={0}
              max={120}
              allowCross={false}
              railStyle={{ background: '#133B57' }}
              tipProps={[{ placement: 'bottom' }]}
              onChange={e => this.handleRangeChange(e, 5)}
            />
          </div>
          <div style={{ width: '10%' }}>
            <strong>Expiration Year:</strong>
            <Range
              defaultValue={[2019, 2024]}
              min={2019}
              max={2024}
              allowCross={false}
              railStyle={{ background: '#133B57' }}
              tipProps={[{ placement: 'bottom' }]}
              onChange={e => this.handleRangeChange(e, 7)}
            />
          </div>
          <div style={{ width: '10%' }}>
            <strong>19-20 CAP HIT:</strong>
            <Range
              defaultValue={[0, 15000000]}
              min={0}
              max={15000000}
              allowCross={false}
              railStyle={{ background: '#133B57' }}
              handle={handle}
              step={500000}
              onChange={e => this.handleRangeChange(e, 6)}
            />
          </div>
          <div style={{ width: '10%' }}>
            <strong>19-20 HENRI:</strong>
            <Range
              defaultValue={[100000, 15000000]}
              min={0}
              max={15000000}
              allowCross={false}
              railStyle={{ background: '#133B57' }}
              handle={handle}
              step={1000000}
              onChange={e => this.handleRangeChange(e, 9)}
            />
          </div>
          <div style={{ width: '10%' }}>
            <strong>20-21 HENRI:</strong>
            <Range
              defaultValue={[100000, 15000000]}
              min={0}
              max={15000000}
              allowCross={false}
              railStyle={{ background: '#133B57' }}
              step={1000000}
              onChange={e => this.handleRangeChange(e, 10)}
            />
          </div>
          <div style={{ width: '10%' }}>
            <strong>19-20 Surplus:</strong>
            <Range
              defaultValue={[-10000000, 10000000]}
              min={-10000000}
              max={10000000}
              allowCross={false}
              railStyle={{ background: '#133B57' }}
              step={1000000}
              onChange={e => this.handleRangeChange(e, 12)}
            />
          </div>
        </div>
        <ReactTable
          toggleActive={this.props.toggleActive}
          data={this.props.players}
          filterable={this.props.filterable}
          showPagination={this.props.showPagination}
          defaultPageSize={this.props.defaultPageSize}
          ref="contractTable"
          getTrProps={(state, rowInfo, column, instance, data) => ({
            onClick: () => {
              this.props.toggleActive(
                instance.props.data[rowInfo.index].player_id
              );
            }
          })}
          defaultSortDesc={true}
          defaultSorted={[{ id: 'henri1920', desc: true }]}
          noDataText={
            <FadeLoader color={'#123abc'} loading={this.state.loading} />
          }
          getNoDataProps={(state, rowInfo, column, instance) => {
            return { style: { background: 'none' } };
          }}
          columns={this.columns}
          defaultPageSize={10}
          className="-striped -highlight"
        />
      </div>
    );
  }
}

//export default PlayerCard;
//render(<PlayerCard />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/Components/ContractTable.js